import {getLocal} from '../hooks/useStorage/useStorage.jsx'

const textsGeneral = {
    en: {
        language: 'Language',
        chooseLanguage: 'Choose the desired language',
        portuguese: 'Portuguese',
        english: 'English',
        spanish: 'Spanish',
        open: 'Open',
        closed: 'Closed',
        onlyProgrammed: 'Only programmed',
        clearData: 'Clear data',
        messageClearData: 'Do you want to clear all data?',
        confirm: 'Confirm',
        cancel: 'Cancel',
        confirmation: 'Confirmation',
        version: 'Version',
        mandatory: 'Mandatory',
        seeBag: 'See bag',
        ok: 'Ok',
        warning: 'Warning',
        closedStore: 'The store is closed!',
        toClose: 'To Close',
        shoppingCart: 'Shopping Cart',
        continue: 'Continue',
        observation: 'Observation',
        observationDelivery: 'Note for delivery',
        chooseAnOption: 'Choose an option',
        paymentMethods: 'Payment methods',
        yes: 'Yes',
        no: 'No',
        minimum: 'Minimum',
        payment: 'Payment',
        profile: 'Profile',
        fillInTheData: 'Fill in the data',
        name: 'Name',
        phone: 'Phone',
        cpf: 'CPF/CNPJ',
        dateOfBirth: 'Date of Birth',
        number: 'Number',
        expiry: 'Expiration date',
        invalidData: 'Invalid data',
        invalidName: 'Invalid name',
        invalidPhone: 'Invalid phone',
        invalidCpf: 'Invalid CPF',
        invalidDateOfBirth: 'Invalid Date of birth',
        invalidCnpj: 'Invalid CNPJ',
        invalidNumber: 'Invalid number',
        invalidDate: 'Invalid date',
        invalidCvc: 'Invalid cvc',
        invalidEmail: 'Invalid email',
        invalidPassword: 'Invalid password',
        invalidEmailOrPassword: 'Invalid email or password',
        forgotMyPassword: 'I forgot my password',
        recoverPassword: 'Recover password',
        warningPasswordRecovery: 'Enter your email to receive the password recovery code',
        codeRecovery: 'Recovery code',
        warningCodeRecovery: 'Enter the recovery code',
        insert: 'Insert',
        remove: 'Remove',
        deliveryForecastBetween: 'Delivery forecast, between',
        withdrawalForecastBetween: 'Withdrawal Forecast, between',
        waitingConfirmation: 'Waiting for confirmation from the restaurant',
        orderConfirmed: 'Order received and being prepared',
        awaitingWithdrawal: 'Order is ready, waiting for collection',
        orderCancelled: 'Order cancelled',
        orderOutForDelivery: 'Pedido saiu para entrega',
        orderDelivered: 'Order delivered',
        orderHistory: 'Order history',
        myOrder: 'My request',
        items: 'Itens',
        information: 'Information',
        orderType: 'Order type',
        status: 'Status',
        pixPaymentNotice: 'The order will only be shipped after payment',
        copiedSuccessfully: 'Copied successfully!',
        failedToCopy: 'Failed to copy!',
        copyPix: 'Copy Pix',
        cancelPix: 'Cancel Pix',
        notifications: 'Notifications',
        noticeNotifications: 'Allow notifications to receive the status of your order',
        allow: 'Allow',
        doNotAllow: 'Do not allow',
        serviceArea: 'Service area',
        openingHours: 'Opening hours',
        closedDelivery: 'Store closed for delivery at the moment!',
        closedTakeaway: 'Store closed for pick up at the moment!',
        date: 'Data',
        warningDateLimit: 'Date less than the order limit',
        search: 'Search',
        copyright: 'Powered by Bitbar',
        discountCoupon: 'Discount coupon',
        rescue: 'Rescue',
        toAlter: 'To alter',
        paymentType: 'Payment type',
        login: 'Login',
        email: 'E-mail',
        password: 'Password',
        repeatPassword: 'Repeat password',
        code: 'Code',
        newPassword: 'New Password',
        enterNewPassword: 'Enter new password',
        invalidCode: 'Invalid code',
        verifyingCode: 'Verifying code...',
        sendingEmail: 'Sending email...',
        generatingCode: 'Generating code...',
        checkingEmail: 'Checking email...',
        passwordChanged: 'Password changed successfully!',
        changingPassword: 'Changing password',
        orderInformation: 'Order information',
        warningInformation: 'Enter the information that will be included in the order',
        reviewAddressData: 'Review address data',
        reviewTheValues: 'Review the values',
        reviewTheOrderInformation: 'Review the order information',
        exitTotemMode: 'Exit Totem Mode',
        wantToExitTotemMode: 'Do you want to exit totem mode?',
        toEdit: 'To edit',
        toDelete: 'To delete',
        time: 'Time',
        noRoutes: 'There are no delivery routes for that date',
        loading: 'Loading...',
        couponAdded: 'Coupon added successfully',
        repeatLastOrder: 'Repeat last order',
        someItemsNotAvailable: 'Some items are not available',
        reviewOrder: 'Review the order, there may be changes to the menu',
        seeRoutes: 'See routes',
        couponUsed: 'This coupon has already been used',
        failure: 'Failure',
        existingRegistration: 'Your email has already been registered, I log in',
        warningPrivacy: 'Privacy Notice',
        messagePrivacy: 'We use local and session storage to save your data (such as name and address) and improve your experience. No information is shared with third parties. By continuing to browse, you agree to our privacy policy.'
    },
    es: {
        language: 'Idioma',
        chooseLanguage: 'Elige el idioma deseado',
        portuguese: 'Portugués',
        english: 'Inglés',
        spanish: 'Español',
        open: 'Abierto',
        closed: 'Cerrado',
        onlyProgrammed: 'Solo programado',
        clearData: 'Borrar datos',
        messageClearData: '¿Quieres borrar todos los datos?',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        confirmation: 'Confirmación',
        version: 'Versión',
        mandatory: 'Paso obligatorio',
        seeBag: 'Ver bolsa',
        ok: 'Ok',
        warning: 'Advertencia',
        closedStore: '¡La tienda está cerrada!',
        toClose: 'Cerrar',
        shoppingCart: 'Carro de la compra',
        continue: 'Continuar',
        observation: 'Observación',
        observationDelivery: 'Nota de entrega',
        chooseAnOption: 'Escoge una opción',
        paymentMethods: 'Formas de pago',
        yes: 'Sí',
        no: 'No',
        payment: 'Pago',
        profile: 'Perfil',
        fillInTheData: 'Rellena los datos',
        name: 'Nombre',
        phone: 'Teléfono',
        cpf: 'CPF/CNPJ',
        dateOfBirth: 'Fecha de nacimiento',
        number: 'Número',
        expiry: 'Fecha de validez',
        invalidData: 'Datos no válidos',
        invalidName: 'Nombre inválido',
        invalidPhone: 'Teléfono no válido',
        invalidCpf: 'CPF no válido',
        invalidDateOfBirth: 'Fecha de nacimiento no válido',
        invalidCnpj: 'CNPJ no válido',
        invalidNumber: 'Número no válido',
        invalidDate: 'Data no válido',
        invalidCvc: 'CVC no válido',
        invalidEmail: 'Correo electrónico no válido',
        invalidPassword: 'Contraseña no válida',
        invalidEmailOrPassword: 'Correo electrónico o señal inválida',
        forgotMyPassword: 'Olvidé mi contraseña',
        recoverPassword: 'Recuperar contraseña',
        warningPasswordRecovery: 'Ingresa tu correo electrónico para recibir el código de recuperación de contraseña',
        codeRecovery: 'Código de recuperación',
        warningCodeRecovery: 'Ingrese el código de recuperación',
        insert: 'Insertar',
        remove: 'Eliminar',
        deliveryForecastBetween: 'Previsión de entrega, entre',
        withdrawalForecastBetween: 'Previsión de retiradas, entre',
        waitingConfirmation: 'Esperando confirmación del restaurante.',
        orderConfirmed: 'Pedido recibido y en preparación',
        awaitingWithdrawal: 'El pedido está listo, a la espera de ser recogido.',
        orderCancelled: 'Orden cancelada',
        orderOutForDelivery: 'El pedido ya está para entrega',
        orderDelivered: 'Pedido entregado',
        orderHistory: 'Historial de pedidos',
        myOrder: 'Mi pedido',
        items: 'Itens',
        information: 'Información',
        orderType: 'Tipo de orden',
        status: 'Estado',
        pixPaymentNotice: 'El pedido sólo se enviará después del pago.',
        copiedSuccessfully: '¡Copiado exitosamente!',
        failedToCopy: '¡No se pudo copiar!',
        copyPix: 'Copiar Pix',
        cancelPix: 'Cancelar Pix',
        notifications: 'Notificaciones',
        noticeNotifications: 'Permitir notificaciones para recibir el estado de su pedido',
        allow: 'Permitir',
        doNotAllow: 'No permitir',
        serviceArea: 'Vía de Servício',
        openingHours: 'Horario de apertura',
        closedDelivery: '¡Tienda cerrada para entrega en este momento!',
        closedTakeaway: '¡Tienda cerrada para recogida en este momento!',
        date: 'Data',
        warningDateLimit: 'Fecha más corta que el límite del pedido',
        search: 'Buscar',
        copyright: 'Desarrollado por Bitbar',
        discountCoupon: 'Cupón de descuento',
        rescue: 'Rescate',
        toAlter: 'Alterar',
        paymentType: 'Tipo de pago',
        login: 'Login',
        email: 'Correo electrónico',
        password: 'Señora',
        repeatPassword: 'Repita la contraseña',
        code: 'Code',
        newPassword: 'Nueva contraseña',
        enterNewPassword: 'Ingrese una nueva contraseña',
        invalidCode: 'Código inválido',
        verifyingCode: 'Código de verificación...',
        sendingEmail: 'Enviando correo electrónico...',
        generatingCode: 'Generando código...',
        checkingEmail: 'Revisando el correo electrónico...',
        passwordChanged: 'contraseña cambiada exitosamente',
        changingPassword: 'Cambiando contraseña',
        orderInformation: 'Información del pedido',
        warningInformation: 'Introduce la información que se incluirá en el pedido.',
        reviewAddressData: 'Revisar los datos de la dirección',
        reviewTheValues: 'Revisar los valores',
        reviewTheOrderInformation: 'Revisar la información del pedido',
        exitTotemMode: 'Salir del modo tótem',
        wantToExitTotemMode: '¿Quieres salir del modo tótem?',
        toEdit: 'Editar',
        toDelete: 'Borrar',
        time: 'Tiempo',
        noRoutes: 'No hay rutas de entrega para esa fecha',
        loading: 'Cargando...',
        couponAdded: 'Cupón añadido exitosamente',
        repeatLastOrder: 'Repetir la última solicitud',
        someItemsNotAvailable: 'Algunos artículos no están disponibles',
        reviewOrder: 'Revisar el pedido, puede haber cambios en el menú.',
        seeRoutes: 'Ver rutas',
        couponUsed: 'Este cupón ya ha sido utilizado',
        failure: 'Falla',
        existingRegistration: 'Tu email ya esta registrado, inicio sesión',
        warningPrivacy: 'Aviso de privacidad',
        messagePrivacy: 'Utilizamos almacenamiento local y de sesión para guardar tus datos (como nombre y dirección) y mejorar tu experiencia. No compartimos información con terceros. Al continuar navegando, aceptas nuestra política de privacidad'
    },
    pt: {
        language: 'Idioma',
        chooseLanguage: 'Escolha o idioma desejado',
        portuguese: 'Português',
        english: 'Inglês',
        spanish: 'Espanhol',
        open: 'Aberto',
        closed: 'Fechado',
        onlyProgrammed: 'Somente programados',
        clearData: 'Limpar dados',
        messageClearData: 'Deseja limpar todos os dados?',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        confirmation: 'Confirmação',
        version: 'Versão',
        mandatory: 'Obrigatório',
        seeBag: 'Ver sacola',
        ok: 'Ok',
        warning: 'Aviso',
        closedStore: 'A Loja está fechada!',
        toClose: 'Fechar',
        shoppingCart: 'Carrinho',
        continue: 'Continuar',
        observation: 'Observação',
        observationDelivery: 'Observação para entrega',
        chooseAnOption: 'Escolha uma opção',
        paymentMethods: 'Forma de pagamento',
        yes: 'Sim',
        no: 'Não',
        payment: 'Pagamento',
        profile: 'Perfil',
        fillInTheData: 'Preencha os dados',
        name: 'Nome',
        phone: 'Telefone',
        cpf: 'CPF/CNPJ',
        dateOfBirth: 'Data de nascimento',
        number: 'Número',
        expiry: 'Data de validade',
        invalidData: 'Dados inválidos',
        invalidName: 'Nome inválido',
        invalidPhone: 'Telefone inválido',
        invalidCpf: 'CPF inválido',
        invalidDateOfBirth: 'Data de nascimento inválida',
        invalidCnpj: 'CNPJ inválido',
        invalidNumber: 'Número inválido',
        invalidDate: 'Data inválida',
        invalidCvc: 'CVC inválido',
        invalidEmail: 'E-mail inválido',
        invalidPassword: 'Senha inválido',
        invalidEmailOrPassword: 'E-mail ou senha inválida',
        forgotMyPassword: 'Esqueci minha senha',
        recoverPassword: 'Recuperar senha',
        warningPasswordRecovery: 'Digite seu e-mail para receber o código de recuperação de senha',
        codeRecovery: 'Código de recuperação',
        warningCodeRecovery: 'Digite o código de recuperação',
        insert: 'Inserir',
        remove: 'Remover',
        deliveryForecastBetween: 'Previsão de entrega, entre',
        withdrawalForecastBetween: 'Previsão de retirada, entre',
        waitingConfirmation: 'Aguardando confirmação do restaurante',
        orderConfirmed: 'Pedido recebido e sendo preparado',
        awaitingWithdrawal: 'O pedido está pronto, esperando para ser retirado.',
        orderCancelled: 'Pedido cancelado',
        orderOutForDelivery: 'Pedido saiu para entrega',
        orderDelivered: 'Pedido entregue',
        orderHistory: 'Histórico de pedidos',
        myOrder: 'Meu pedido',
        items: 'Itens',
        information: 'Informação',
        orderType: 'Tipo Pedido',
        status: 'Status',
        pixPaymentNotice: 'O pedido só será enviado após do pagamento',
        copiedSuccessfully: 'Copiado com sucesso!',
        failedToCopy: 'Falha ao copiar!',
        copyPix: 'Copiar Pix',
        cancelPix: 'Cancelar Pix',
        notifications: 'Notificações',
        noticeNotifications: 'Permita as notificações para receber o status do seu pedido',
        allow: 'Permitir',
        doNotAllow: 'Não permitir',
        serviceArea: 'Área de atendimento',
        openingHours: 'Horário de atendimento',
        closedDelivery: 'Loja fechada para delivery no momento!',
        closedTakeaway: 'Loja fechada para retirada no momento!',
        date: 'Data',
        warningDateLimit: 'Data selecionada é inferior a data mínima para pedidos!',
        search: 'Buscar',
        copyright: 'Desenvolvido por Bitbar',
        discountCoupon: 'Cupom de desconto',
        rescue: 'Resgatar',
        toAlter: 'Alterar',
        paymentType: 'Tipo de pagamento',
        login: 'Login',
        email: 'E-mail',
        password: 'Senha',
        repeatPassword: 'Repetir senha',
        code: 'Código',
        newPassword: 'Nova senha',
        enterNewPassword: 'Digite a nova senha',
        invalidCode: 'Código inválido',
        verifyingCode: 'Verificando código...',
        sendingEmail: 'Enviando e-mail...',
        generatingCode: 'Gerando código...',
        checkingEmail: 'Verificando e-mail...',
        passwordChanged: 'Senha alterada com sucesso!',
        changingPassword: 'Alterando senha',
        orderInformation: 'Informações do pedido',
        warningInformation: 'Digite as informações que serão incluídas no pedido',
        reviewAddressData: 'Revise os dados do endereço',
        reviewTheValues: 'Revise os valores',
        reviewTheOrderInformation: 'Revise as informações do pedido',
        exitTotemMode: 'Sair do modo totem',
        wantToExitTotemMode: 'Deseja sair do modo totem?',
        toEdit: 'Editar',
        toDelete: 'Deletar',
        time: 'Horário',
        noRoutes: 'Não há rotas de entrega para essa data',
        loading: 'Carregando...',
        couponAdded: 'Cupom resgatado com sucesso!',
        repeatLastOrder: 'Repetir o último pedido',
        someItemsNotAvailable: 'Alguns itens não estão disponíveis',
        reviewOrder: 'Revise o pedido, pode haver alterações no cardápio',
        seeRoutes: 'Ver rotas',
        couponUsed: 'Este cupom já foi utilizado',
        failure: 'Falha!',
        existingRegistration: 'Seu e-mail já foi registrado, faço o login',
        warningPrivacy: 'Aviso de privacidade',
        messagePrivacy: 'Usamos armazenamento local e de sessão para salvar seus dados (como nome e endereço) e melhorar sua experiência. Nenhuma informação é compartilhada com terceiros. Ao continuar navegando, você concorda com nossa politica de privacidade.'
    }
}

const textsItemBag = {
    en: {
        title: 'Bag',
        addToCart: 'Add to cart',
        toReplace: 'To replace',
        toAdd: 'To add',
        toAlter: 'To alter',
        limitMaximum: 'Maximum selection reached!',
        limitMinimum: 'Minimum selection not reached!',
        mandatoryStep: 'Mandatory step',
        maximumQuantity: 'This item has a maximum quantity of ',
        minimumQuantity: 'This item has a minimum quantity of ',
        limitPerOrder: 'This item has reached the limit per order',
        byFlavor: 'by flavor',
        quantity: 'Quantity',
        order: 'Order',
        notApplied: 'Not applied',
        summaryValues: 'Summary values'
    },
    es: {
        title: 'Bolsa',
        addToCart: 'Para agregar',
        toReplace: 'Para reemplazar',
        toAdd: 'Para agregar',
        toAlter: 'Alterar',
        limitMaximum: '¡Selección máxima alcanzada!',
        limitMinimum: '¡Selección mínima no alcanzada!',
        mandatoryStep: 'Paso obligatorio',
        maximumQuantity: 'Este artículo tiene una cantidad máxima de ',
        minimumQuantity: 'Este artículo tiene una cantidad mínima de ',
        limitPerOrder: 'Este artículo ha alcanzado el límite por pedido.',
        byFlavor: 'por sabor',
        quantity: 'Cantidad',
        order: 'Ordern',
        notApplied: 'No aplicado',
        summaryValues: 'Valores de resumen'
    },
    pt: {
        title: 'Sacola',
        addToCart: 'Adicionar',
        toAdd: 'Adicionar',
        toReplace: 'Trocar',
        toAlter: 'Alterar',
        limitMaximum: 'Seleção máxima atingida!',
        limitMinimum: 'Seleção mínima não atingida!',
        mandatoryStep: 'Etapa obrigatória',
        maximumQuantity: 'Este item tem uma quantidade máxima de ',
        minimumQuantity: 'Este item tem uma quantidade mínima de ',
        limitPerOrder: 'Este item atingiu o limite por pedido',
        byFlavor: 'por sabor',
        quantity: 'Quantidade',
        order: 'Pedido',
        notApplied: 'Não aplicado',
        summaryValues: 'Resumo valores'
    }
}

const textShoppingCart = {
    en: {
        addedItems: 'Added items',
        addItemsToCart: 'Add items to cart',
        itemsRemovedFromCart: 'Some items have been removed from the cart!',
        cleanCart: 'Clean cart',
        deliverTo: 'Deliver to',
        takeawayTo: 'Withdraw order at',
        descriptionOfValues: 'Description of values',
        subtotal: 'Subtotal',
        deliveryFee: 'Delivery fee',
        total: 'Total',
        sendRequest: 'Send request',
        discountCoupon: 'Discount coupon',
        validateCoupon: 'Insert coupon for validation',
        invalidCoupon: 'Invalid coupon',
        checkingDiscountCoupon: 'Checking discount coupon',
        minimumPurchaseDiscountNotice: 'This coupon has a minimum purchase of',
        minimumPurchase: 'The minimum purchase value for delivery is ',
        discount: 'Discount',
        withDiscount: 'With discount',
        addItemsToUseTheCoupon: 'Add items to cart to use this coupon!',
        deliveryCouponInvalidForTakeaway: 'This coupon is only valid for delivery orders, select the delivery address and enter the coupon again.',
        productNotFound: 'Product not found',
        sendingRequest: 'Sending request...',
        orderSentSuccessfully: 'Order sent successfully',
        trackOrder: 'Track order',
        reviewInformation: 'Review information',
        questions: 'Questions',
        cashback: 'Cashback',
        redeemCashback: 'Redeem cashback',
        earnCashback: 'Earn cashback',
        cpf: 'CPF',
        balance: 'Balance',
        wantToRescue: 'Do you want to redeem a cashback amount?',
        valueToBeRedeemed: 'Value to be redeemed',
        initialBalance: 'Initial balance',
        finalBalance: 'Final balance',
        minimumRescue: 'Minimum redemption of',
        maximumRescue: 'It is not possible to redeem an amount greater than the total order amount',
        scheduleOrder: 'Schedule order',
        immediate: 'Immediate',
        scheduled: 'Scheduled',
        immediateRequest: 'Immediate request',
        scheduledOrder: 'Scheduled order',
        availableTimes: 'Available times',
        deliveryDate: 'Delivery date',
        chooseDeliveryDate: 'Choose a delivery date',
        flavorAssistant: 'Flavor assistant',
        textAssistant: 'List of extras for my order',
        warningTourAssistant: 'Click here to see the chosen flavors',
        warningTourFilter: 'Click here to filter flavors',
        cashbackRemoved: 'The cashback redeemable amount has been removed',
        couponRemoved: 'the discount coupon has been removed',
        totalToPay: 'Total to pay',
        buyWithoutRegistration: 'Buy without registration',
        registered: 'I am already registered',
        pay: 'Pay',
        register: 'Registre',
        observationOrder: 'Enter order notes, for example: broken intercom'
    },
    es: {
        addedItems: 'Elementos agregados',
        addItemsToCart: 'Agregar artículos al carrito',
        itemsRemovedFromCart: '¡Algunos artículos han sido eliminados del carrito!',
        cleanCart: 'Carro limpio',
        deliverTo: 'Entregar a',
        takeawayTo: 'Retirar orden en',
        descriptionOfValues: 'Descripción de valores',
        subtotal: 'Total parcial',
        deliveryFee: 'Gastos de envío',
        total: 'Total',
        sendRequest: 'Enviar petición',
        discountCoupon: 'Cupón de descuento',
        validateCoupon: 'Insertar cupón para validación',
        invalidCoupon: 'Cupón no válido',
        checkingDiscountCoupon: 'Comprobando cupón de descuento',
        minimumPurchaseDiscountNotice: 'Este cupón tiene una compra mínima de',
        minimumPurchase: 'El valor mínimo de compra para entrega es de ',
        discount: 'Descuento',
        withDiscount: 'Con descuento',
        addItemsToUseTheCoupon: '¡Agregue artículos al carrito para usar este cupón!',
        deliveryCouponInvalidForTakeaway: 'Este cupón solo es válido para pedidos a domicilio, seleccione la dirección de entrega e ingrese el cupón nuevamente.',
        productNotFound: 'Producto no encontrado',
        sendingRequest: 'Enviando el pedido...',
        orderSentSuccessfully: 'Pedido enviado exitosamente',
        trackOrder: 'Orden de pista',
        reviewInformation: 'Revisar información',
        questions: 'Preguntas',
        cashback: 'Cashback',
        redeemCashback: 'Canjear reembolso',
        earnCashback: 'Ganar reembolso',
        cpf: 'CPF',
        balance: 'Balance',
        wantToRescue: '¿Quieres canjear un monto de reembolso?',
        valueToBeRedeemed: 'Valor para canjear',
        initialBalance: 'Saldo inicial',
        finalBalance: 'Saldo final',
        minimumRescue: 'Reembolso mínimo de',
        maximumRescue: 'No es posible canjear un importe mayor al importe total del pedido',
        scheduleOrder: 'Orden de programación',
        immediate: 'Inmediata',
        scheduled: 'Programada',
        immediateRequest: 'orden inmediata',
        scheduledOrder: 'Orden programada',
        availableTimes: 'Tiempos disponibles',
        deliveryDate: 'Fecha de entrega',
        chooseDeliveryDate: 'Elija una fecha de entrega',
        flavorAssistant: 'Asistente de sabor',
        textAssistant: 'Lista de extras para mi pedido',
        warningTourAssistant: 'Haz clic aquí para ver los sabores elegidos',
        warningTourFilter: 'Haga clic aquí para filtrar sabores',
        cashbackRemoved: 'El monto canjeable del reembolso ha sido eliminado',
        couponRemoved: 'El cupón de descuento ha sido eliminado',
        totalToPay: 'Total a pagar',
        buyWithoutRegistration: 'Comprar sin registro',
        registered: 'Ya estoy registrado',
        pay: 'Pagar',
        register: 'Registro',
        observationOrder: 'Introduzca notas del pedido, por ejemplo: intercomunicador roto'
    },
    pt: {
        addedItems: 'Itens adicionados',
        addItemsToCart: 'Adicionar itens ao carrinho',
        itemsRemovedFromCart: 'Alguns itens foram removidos do carrinho!',
        cleanCart: 'Limpar carrinho',
        deliverTo: 'Entregar',
        takeawayTo: 'Retirar',
        descriptionOfValues: 'Descrição dos valores',
        subtotal: 'Subtotal',
        deliveryFee: 'Taxa de entrega',
        total: 'Total',
        sendRequest: 'Enviar pedido',
        discountCoupon: 'Cupom de desconto',
        validateCoupon: 'Insira cupom para validação',
        invalidCoupon: 'Cupom inválido',
        checkingDiscountCoupon: 'Verificando cupom de desconto',
        minimumPurchaseDiscountNotice: 'Este cupom tem uma compra mínima de',
        minimumPurchase: 'O valor mínimo de compra para entrega é de ',
        discount: 'Desconto',
        withDiscount: 'Com desconto',
        addItemsToUseTheCoupon: 'Adicione itens ao carrinho para usar esse cupom!',
        deliveryCouponInvalidForTakeaway: 'Este cupom só é válido para pedidos entrega, selecione o endereço de entrega e insira o cupom novamente.',
        productNotFound: 'Produto não encontrado',
        sendingRequest: 'Enviando pedido...',
        orderSentSuccessfully: 'Pedido enviado com sucesso',
        trackOrder: 'Acompanhar pedido',
        reviewInformation: 'Revisar pedido',
        questions: 'Perguntas',
        cashback: 'Cashback',
        redeemCashback: 'Resgate cashback',
        earnCashback: 'Ganho cashback',
        cpf: 'CPF',
        balance: 'Saldo',
        wantToRescue: 'Deseja resgatar um valor de cashback?',
        valueToBeRedeemed: 'Valor a resgatar',
        initialBalance: 'Saldo inicial',
        finalBalance: 'Saldo final',
        minimumRescue: 'Resgate mínimo de',
        maximumRescue: 'Não é possível resgatar um valor maior que o valor total do pedido',
        scheduleOrder: 'Programar pedido',
        immediate: 'Imediato',
        scheduled: 'Programado',
        immediateRequest: 'Pedido imediato',
        scheduledOrder: 'Pedido programado',
        availableTimes: 'Horários disponíveis',
        deliveryData: 'Data de entrega',
        chooseDeliveryDate: 'Escolha uma data de entrega',
        flavorAssistant: 'Assistente de sabor',
        textAssistant: 'Lista de adicionais no pedido',
        warningTourAssistant: 'Clique aqui para ver os sabores escolhidos',
        warningTourFilter: 'Clique aqui para filtrar sabores',
        cashbackRemoved: 'O valor a resgatar do cashback foi removido',
        couponRemoved: 'O cupom de desconto foi removido',
        totalToPay: 'Total a pagar',
        buyWithoutRegistration: 'Comprar sem cadastro',
        registered: 'Já sou cadastrado',
        pay: 'Pagar',
        register: 'Cadastre-se',
        observationOrder: '⚠️ Atenção! Essas observações são só para o motoboy e não alteram o pedido. Use apenas para instruções de entrega, como "interfone quebrado", "ligar ao chegar" ou "casa dos fundos".'
    }
}

const textsAddress = {
    en: {
        address: 'Address',
        takeaway: 'Take-away',
        delivery: 'Delivery',
        deliveryRoute: 'Delivery route',
        enterTheZipCode: 'Enter the delivery zip code',
        zipCode: 'Zip code',
        iDontKnowTheZipCode: "I don't know the zip code",
        registerAddress: 'Register address',
        registerNewAddress: 'Enter the data to register a new address',
        street: 'Street',
        neighborhood: 'Neighborhood',
        city: 'City',
        selectNeighborhood: 'Select neighborhood',
        selectCity: 'Select city',
        addressComplement: 'Address complement',
        invalidStreet: 'Invalid street',
        invalidNeighborhood: 'Invalid neighborhood',
        invalidZipCode: 'Invalid zip code',
        invalidCity: 'Invalid city',
        invalidNumber: 'Invalid number',
        selectDeliveryAddress: 'Select delivery address',
        selectTakeawayMode: 'Select the order pickup method',
        weDoNotServeYourRegion: "We don't serve your region, but it is possible to register another address.",
        outsideServiceRadius: "This address is outside our service radius",
        searchingForZipCode: 'Searching for zip code...',
        hasNoComplement: 'I have no complement',
        confirmationNotComplement: 'Confirm that there is no complement in the address',
        zipCodeNotFound: 'Zip code not found!',
        chooseDeliveryTakeaway: 'Choose between delivery or pick-up',
        coordinatesNotFound: 'The coordinates could not be found'
    },
    es: {
        address: 'Dirección',
        takeaway: 'Para llevar',
        delivery: 'Entrega',
        deliveryRoute: 'Ruta de entrega',
        enterTheZipCode: 'Ingrese el código postal de entrega',
        zipCode: 'Código postal',
        iDontKnowTheZipCode: "No se el codigo postal",
        registerAddress: 'Dirección de registro',
        registerNewAddress: 'Ingrese los datos para registrar una nueva dirección',
        street: 'Camino',
        neighborhood: 'Vecindario',
        city: 'Ciudad',
        selectNeighborhood: 'Seleccione barrio',
        selectCity: 'Seleccione ciudad',
        addressComplement: 'Complemento de dirección',
        invalidStreet: 'Calle inválida',
        invalidNeighborhood: 'Barrio inválido',
        invalidZipCode: 'Código postal no válido',
        invalidCity: 'Ciudad inválida',
        invalidNumber: 'Número invalido',
        selectDeliveryAddress: 'Seleccione la dirección de entrega',
        selectTakeawayMode: 'Seleccione el método de recogida del pedido',
        weDoNotServeYourRegion: "No prestamos servicios en su región, pero es posible registrar otra dirección.",
        outsideServiceRadius: "Esta dirección está fuera de nuestro radio de servicio.",
        searchingForZipCode: 'Buscando codigo postal...',
        hasNoComplement: 'no tengo complemento',
        confirmationNotComplement: 'Confirma que no hay ningún complemento en la dirección',
        zipCodeNotFound: '¡Código postal no encontrado!',
        chooseDeliveryTakeaway: 'Elige entre entrega o recogida',
        coordinatesNotFound: 'No se pudieron encontrar las coordenadas'
    },
    pt: {
        address: 'Endereço',
        takeaway: 'Retirada',
        delivery: 'Entrega',
        deliveryRoute: 'Rota de entrega',
        enterTheZipCode: 'Digite o CEP da entrega',
        zipCode: 'CEP',
        iDontKnowTheZipCode: 'Não sei meu CEP',
        registerAddress: 'Cadastrar endereço',
        registerNewAddress: 'Insira os dados para cadastrar um novo endereço',
        street: 'Rua',
        neighborhood: 'Bairro',
        city: 'Cidade',
        selectNeighborhood: 'Selecione o bairro',
        selectCity: 'Selecione a cidade',
        addressComplement: 'Complemento ou Ponto de referência',
        invalidStreet: 'Rua inválida',
        invalidNeighborhood: 'Bairro inválido',
        invalidZipCode: 'CEP inválido',
        invalidCity: 'Cidade inválida',
        invalidNumber: 'Número inválido',
        selectDeliveryAddress: 'Selecione o endereço de entrega',
        selectTakeawayMode: 'Selecione o modo de retirada',
        weDoNotServeYourRegion: "Não atendemos sua região, mas é possível cadastrar outro endereço.",
        outsideServiceRadius: "Este endereço está fora do nosso raio de atendimento",
        searchingForZipCode: 'Buscando CEP...',
        hasNoComplement: 'Não tenho complemento',
        confirmationNotComplement: 'Confirme se não há complemento no endereço',
        zipCodeNotFound: 'CEP não encontrado!',
        chooseDeliveryTakeaway: 'Escolha entre entrega ou retirada',
        coordinatesNotFound: 'As coordenadas não puderam ser encontradas'
    }
}

const textsPaymentMethods = {
    en: {
        onlinePayment: 'Online payment',
        physicalPayment: 'Physical payment',
        change: 'Change',
        doYouNeedChange: 'Do you need change?',
        howMuchDoIExchange: 'How much do I exchange?',
        invalidValue: 'Invalid value',
        changeLessThanTotal: 'The amount of change value be less than the total',
        changeMoreThanTotal: 'The amount of change value is much more than the total',
        pix: 'Pix',
        payCounter: 'Pay at the counter'
    },
    es: {
        onlinePayment: 'Pago en línea',
        physicalPayment: 'Pago fisico',
        change: 'Cambiar',
        doYouNeedChange: '¿Necesitas cambio?',
        howMuchDoIExchange: '¿Cuánto cambio?',
        invalidValue: 'Valor no válido',
        changeLessThanTotal: 'La cantidad de cambio no puede ser menor que el total',
        changeMoreThanTotal: 'El valor del cambio es mayor que el total',
        pix: 'Pix',
        payCounter: 'Pagar en el mostrador'
    },
    pt: {
        onlinePayment: 'Pagamento online',
        physicalPayment: 'Pagamento físico',
        change: 'Troco',
        doYouNeedChange: 'Precisa de troco?',
        howMuchDoIExchange: 'Troco para quanto?',
        invalidValue: 'Valor inválido',
        changeLessThanTotal: 'O valor do troco não pode ser menor que o total',
        changeMoreThanTotal: 'O valor do troco é muito que o total',
        pix: 'Pix',
        payCounter: 'Pagar no balcão'
    }
}

const textsAddCard = {
    en: {
        card: 'Card',
        addCard: 'Add card'
    },
    es: {
        card: 'Tarjeta',
        addCard: 'Agregar tarjeta'
    },
    pt: {
        card: 'Cartão',
        addCard: 'Adicionar cartão'
    }
}

const general = textsGeneral[(!!getLocal('language')) ? getLocal('language') : 'pt']
const itemBag = textsItemBag[(!!getLocal('language')) ? getLocal('language') : 'pt']
const shoppingCart = textShoppingCart[(!!getLocal('language')) ? getLocal('language') : 'pt']
const address = textsAddress[(!!getLocal('language')) ? getLocal('language') : 'pt']
const paymentMethods = textsPaymentMethods[(!!getLocal('language')) ? getLocal('language') : 'pt']
const addCard = textsAddCard[(!!getLocal('language')) ? getLocal('language') : 'pt']

export {
    itemBag,
    general,
    shoppingCart,
    address,
    paymentMethods,
    addCard
}
